<template>
  <div>
    <!-- <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" :prentType="prentType" :shopList="shopList" /> -->
    <!--    FBA -&ndash;&gt; 打包完成 btns： 有 '导出发货单'、'批量修改物流公司'、'批量确认发货'-->
    <!--    大包 -&ndash;&gt; 打包完成 btns： 有 '导出发货单'、'批量修改物流公司'、'批量确认发货'-->
    <!--    小包 -&ndash;&gt; 打包完成 btns： 有 '导出发货单'、'批量修改物流公司'、'批量获取运单号'、'批量确认发货'-->
    <InterBtnBox :selectedRows="selectedRows" modify-btn finish-btn @overEmit="getDataSource" @refeash="getDataSource"
      :singleProduct="query.singleProduct" :prentType="prentType" tableType="builtBag"/>
    <InterList :dataSource="dataSource" tableType="builtBag" :layout="prentType == 'smallBag' ? 'logistics' : ''"
      :prentType="prentType" :clean="clean" @pageChange="pageChangeCall" :singleProduct="query.singleProduct"
      @refeash="getDataSource" @selectChange="selectChangeCall" @change="change" ref="interlist" :forwarder="$attrs.forwarder" :total="query.total"></InterList>
  </div>
</template>

<script>
import InterForm from "@/views/outOfStock/internationalShipment/components/InterForm";
import InterList from "@/views/outOfStock/internationalShipment/components/InterList";
import InterBtnBox from "@/views/outOfStock/internationalShipment/components/InterBtnBox";
import { deliveryStatus, deliveryTypes } from "@/views/outOfStock/internationalShipment/tabs/index";
import { shipTask } from "@/apis/outStock";
import { setTimeout } from 'timers';

export default {
  title: '打包完成',
  name: "builtBag", // 打包完成
  components: {
    InterForm,
    InterList,
    InterBtnBox
  },
  props: {
    prentType: String,
    shopList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      query: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      clean: false,
      selectedRows: [],
      dataSource: []
    }
  },
  methods: {
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      }
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource()
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows
    },
    getDataSource: function () {
      // 获取列表数据
      this.selectedRows = []
      const params = {
        ...this.query,
        pageNum: this.query.current,
        deliveryStatus: deliveryStatus['builtBag'],
        deliveryType: deliveryTypes[this.prentType]
      }
      this.clean = true
      shipTask(params).then(res => {
        const { data: { total = 0, records = [] } } = res
        records.forEach(item => {
          let text = ''
          if (item.channelNo && item.logisticsChannelDTOList) {
            item.logisticsChannelDTOList.forEach(item_son => {
              if (item_son.channelNo == item.channelNo) {
                text = item_son.channelName
              }
            })
          }
          item.channelNo = text
        })
        this.query.total = total
        this.dataSource = records
      }).finally(_ => {
        this.clean = false
      })
    },
    change() {
      setTimeout(() => {
        this.getDataSource();
      }, 3000)
    }
  }
}
</script>

<style scoped>
</style>